export default "/kiban/_next/static/images/06_2L_cupper_core-9e0dc85e0544c840c2dab19b6a84da34.png";